"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGreyscaleColor = exports.WeightConst = exports.SpacingConst = exports.SizeConst = exports.RotateConst = exports.OverflowConst = exports.PositionConst = exports.JustifyContentConst = exports.IconNameConst = exports.FlexWrapConst = exports.FlexDirectionConst = exports.DisplayConst = exports.ColorsGreyscaleConst = exports.ColorsConst = exports.AsConst = exports.AlignItemsConst = void 0;
const types_1 = require("../../styles/types");
const ColorsGreyscaleConst = [
    "white",
    "cloud",
    "dishwater",
    "silver",
    "stone",
    "metal",
    "zinc",
    "night",
];
exports.ColorsGreyscaleConst = ColorsGreyscaleConst;
/**
 * Utility to check that a string is part of ColorsGreyscale
 */
const isGreyscaleColor = ($color) => ColorsGreyscaleConst.some((c) => c === $color);
exports.isGreyscaleColor = isGreyscaleColor;
const ColorsConst = [
    "blue",
    "green",
    "orange",
    "pink",
    "purple",
    "red",
    "yellow",
    "greyscale", // TODO: Work with new designer to remove this value
];
exports.ColorsConst = ColorsConst;
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- we may need these constants in story files
const RadiusConst = ["round", "square"];
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- we may need these constants in story files
const AppearanceConst = [
    "ghost",
    "outline",
    "solid",
    "primary",
    "secondary",
    "danger",
    "tertiary",
    "tertiary-inverted",
];
const IconNameConst = types_1.IconNameList;
exports.IconNameConst = IconNameConst;
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- we may need these constants in story files
const LuminosityConst = ["high", "low"];
const SizeConst = [
    "xsmall",
    "small",
    "medium",
    "large",
    "xlarge",
    "xxlarge",
    "xxxlarge",
];
exports.SizeConst = SizeConst;
const WeightConst = ["bold", "regular"];
exports.WeightConst = WeightConst;
const RotateConst = ["0", "90", "180", "270"];
exports.RotateConst = RotateConst;
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- we may need these constants in story files
const DirectionConst = ["ltr", "rtl"];
const SpacingConst = [
    "0",
    "0.25",
    "0.5",
    "1",
    "1.5",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
];
exports.SpacingConst = SpacingConst;
/** Flex & Grid */
const AlignItemsConst = [
    "baseline",
    "center",
    "end",
    "flex-end",
    "flex-start",
    "start",
    "stretch",
];
exports.AlignItemsConst = AlignItemsConst;
const DisplayConst = [
    "flex",
    "inline-flex",
    "grid",
    "inline-grid",
    "block",
    "inline",
    "inline-block",
    "none",
];
exports.DisplayConst = DisplayConst;
const FlexDirectionConst = [
    "row",
    "row-reverse",
    "column",
    "column-reverse",
];
exports.FlexDirectionConst = FlexDirectionConst;
const FlexWrapConst = ["nowrap", "wrap", "wrap-reverse"];
exports.FlexWrapConst = FlexWrapConst;
const JustifyContentConst = [
    "center",
    "end",
    "flex-end",
    "flex-start",
    "space-around",
    "space-between",
    "space-evenly",
    "start",
];
exports.JustifyContentConst = JustifyContentConst;
const AsConst = [
    "div",
    "span",
    "p",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "label",
    "legend",
    "dt",
    "dd",
    "li",
    "th",
    "td",
    "main",
    "header",
    "footer",
    "nav",
    "section",
    "ul",
    "ol",
];
exports.AsConst = AsConst;
const PositionConst = [
    "static",
    "relative",
    "absolute",
    "fixed",
    "sticky",
];
exports.PositionConst = PositionConst;
const OverflowConst = ["visible", "hidden", "clip", "scroll", "auto"];
exports.OverflowConst = OverflowConst;
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- we may need these constants in story files
const ThemeConst = [
    "appearance",
    "backgroundColor",
    "color",
    "luminosity",
    "radius",
    "size",
    "weight",
];
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- we may need these constants in story files
const LayoutConst = [
    "alignItems",
    "columns",
    "column",
    "display",
    "flex",
    "flexDirection",
    "flexWrap",
    "gap",
    "justifyContent",
    "rows",
    "row",
    "minWidth",
    "minHeight",
    "position",
    "top",
    "left",
    "bottom",
    "right",
    "overflow",
    "overflowY",
    "overflowX",
    "m",
    "mx",
    "my",
    "mt",
    "mr",
    "mb",
    "ml",
    "p",
    "px",
    "py",
    "pt",
    "pr",
    "pb",
    "pl",
];
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- we may need these constants in story files
const DimensionConst = ["width", "maxWidth", "height", "maxHeight"];
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- we may need these constants in story files
const EventHandlerConst = [
    "onOpenAutoFocus",
    "onOpenChange",
    "onCheckedChange",
    "onCloseAutoFocus",
    "onValueChange",
];
//# sourceMappingURL=Props.js.map